var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Qr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.144,
    height: 59.149,
    viewBox: "0 0 59.144 59.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M5.464,19.017V5.463H19.018a1.232,1.232,0,0,0,0-2.464H4.232A1.233,1.233,0,0,0,3,4.231V19.017A1.232,1.232,0,0,0,5.464,19.017Z",
    transform: "translate(-3 -2.999)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M19.018,34.781H5.464V21.227a1.232,1.232,0,0,0-2.464,0V36.013a1.233,1.233,0,0,0,1.232,1.232H19.018A1.232,1.232,0,0,0,19.018,34.781Z",
    transform: "translate(-3 21.903)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M37.245,4.231A1.233,1.233,0,0,0,36.012,3H21.226a1.232,1.232,0,0,0,0,2.464H34.78V19.017a1.232,1.232,0,0,0,2.464,0Z",
    transform: "translate(21.899 -2.999)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M34.78,21.227V34.781H21.226a1.232,1.232,0,0,0,0,2.464H36.012a1.233,1.233,0,0,0,1.232-1.232V21.227A1.232,1.232,0,0,0,34.78,21.227Z",
    transform: "translate(21.899 21.903)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M8,11.7a1.233,1.233,0,0,0,1.232,1.232H11.7A1.233,1.233,0,0,0,12.929,11.7V9.231A1.233,1.233,0,0,0,11.7,8H9.232A1.233,1.233,0,0,0,8,9.231Z",
    transform: "translate(4.322 4.323)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M7.232,6A1.233,1.233,0,0,0,6,7.231V19.553a1.233,1.233,0,0,0,1.232,1.232H19.554a1.233,1.233,0,0,0,1.232-1.232V7.231A1.233,1.233,0,0,0,19.554,6ZM8.464,8.463h9.857v9.857H8.464Z",
    transform: "translate(1.393 1.394)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M12.929,21.231A1.233,1.233,0,0,0,11.7,20H9.232A1.233,1.233,0,0,0,8,21.231V23.7a1.233,1.233,0,0,0,1.232,1.232H11.7A1.233,1.233,0,0,0,12.929,23.7Z",
    transform: "translate(4.322 21.895)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M20.786,19.231A1.233,1.233,0,0,0,19.554,18H7.232A1.233,1.233,0,0,0,6,19.231V31.553a1.233,1.233,0,0,0,1.232,1.232H19.554a1.233,1.233,0,0,0,1.232-1.232Zm-2.464,11.09H8.464V20.463h9.857Z",
    transform: "translate(1.393 18.966)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M20,11.7a1.233,1.233,0,0,0,1.232,1.232H23.7A1.233,1.233,0,0,0,24.929,11.7V9.231A1.233,1.233,0,0,0,23.7,8H21.232A1.233,1.233,0,0,0,20,9.231Z",
    transform: "translate(21.894 4.323)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M18,19.553a1.233,1.233,0,0,0,1.232,1.232H31.554a1.233,1.233,0,0,0,1.232-1.232V7.231A1.233,1.233,0,0,0,31.554,6H19.232A1.233,1.233,0,0,0,18,7.231Zm2.464-11.09h9.857v9.857H20.464Z",
    transform: "translate(18.965 1.394)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M10.227,21.386h9.857a1.232,1.232,0,0,0,0-2.464h-3.7v-3.7a1.232,1.232,0,0,0-2.464,0v3.7h-3.7A1.232,1.232,0,0,0,10.227,21.386Z",
    transform: "translate(5.792 13.114)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M15.464,9.69V7.225a1.232,1.232,0,0,0-2.464,0V9.69A1.232,1.232,0,0,0,15.464,9.69Z",
    transform: "translate(11.643 1.4)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M14.227,14.392h4.929a1.233,1.233,0,0,0,1.232-1.232v-3.7H21.62A1.232,1.232,0,0,0,21.62,7H19.155a1.233,1.233,0,0,0-1.232,1.232v3.7h-3.7A1.232,1.232,0,0,0,14.227,14.392Z",
    transform: "translate(11.649 2.858)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M14.227,20.856h4.929a1.232,1.232,0,0,0,0-2.464H17.923V13.463h3.7a1.232,1.232,0,0,0,0-2.464H16.691a1.233,1.233,0,0,0-1.232,1.232v6.161H14.227A1.232,1.232,0,0,0,14.227,20.856Z",
    transform: "translate(11.649 8.716)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M17,16.69a1.232,1.232,0,0,0,2.464,0V14.225a1.232,1.232,0,0,0-2.464,0Z",
    transform: "translate(17.501 11.65)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M15.464,24.386h2.464v1.232a1.232,1.232,0,0,0,2.464,0V18.225a1.232,1.232,0,0,0-2.464,0v3.7h-3.7A1.233,1.233,0,0,0,13,23.154v2.464a1.232,1.232,0,0,0,2.464,0Z",
    transform: "translate(11.643 17.507)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M23.852,21.225v1.232H22.619a1.233,1.233,0,0,0-1.232,1.232v3.7H15.227a1.232,1.232,0,0,0,0,2.464h7.393a1.233,1.233,0,0,0,1.232-1.232v-3.7h1.232a1.233,1.233,0,0,0,1.232-1.232V21.225A1.232,1.232,0,0,0,23.852,21.225Z",
    transform: "translate(13.113 21.9)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M22.459,22.225v3.7H21.226a1.232,1.232,0,0,0,0,2.464h7.393a1.232,1.232,0,0,0,0-2.464h-3.7v-3.7A1.232,1.232,0,0,0,22.459,22.225Z",
    transform: "translate(21.899 23.365)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M29.852,19.231A1.233,1.233,0,0,0,28.619,18H21.226a1.232,1.232,0,0,0,0,2.464h6.161v3.7a1.232,1.232,0,0,0,2.464,0Z",
    transform: "translate(21.899 18.966)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M26.923,15.225a1.232,1.232,0,0,0-2.464,0v3.7H23.226a1.232,1.232,0,0,0,0,2.464h2.464a1.233,1.233,0,0,0,1.232-1.232Z",
    transform: "translate(24.828 13.114)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M26.852,21.624V15.463h1.232a1.232,1.232,0,0,0,0-2.464H25.619a1.233,1.233,0,0,0-1.232,1.232v6.161h-3.7a1.233,1.233,0,0,0-1.232,1.232v3.7H18.226a1.232,1.232,0,0,0,0,2.464h2.464a1.233,1.233,0,0,0,1.232-1.232v-3.7h3.7A1.233,1.233,0,0,0,26.852,21.624Z",
    transform: "translate(17.506 11.644)",
    fill: "#ff5a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M6,14.225v7.393a1.232,1.232,0,0,0,2.464,0v-3.7h3.7a1.232,1.232,0,0,0,0-2.464h-3.7V14.225a1.232,1.232,0,0,0-2.464,0Z",
    transform: "translate(1.393 11.65)",
    fill: "#ff5a2c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/Qr.a225602b87c47e701b4e88caaff5aeb3.svg";
export { ForwardRef as ReactComponent };